// extracted by mini-css-extract-plugin
module.exports = {"radio":"RadioInput_radio__sWLMg","radio__input":"RadioInput_radio__input__x15uj","radio__label":"RadioInput_radio__label__B456a"};